import { CreatePartnerDTO } from "@/domain/dto/CreatePartnerDTO";
import { PartnerCreateResponseDTO } from "@/infrastructure/dto/PartnerCreateResponseDTO";
import { PartnerListResponseDTO } from "@/infrastructure/dto/PartnerListResponseDTO";
import { PartnerShowResponseDTO } from "@/infrastructure/dto/PartnerShowResponseDTO";
import { IPartnerRemoteDataSource } from "../../interfaces/remote/IPartnerRemoteDataSource";
import { UpdatePlanExpirationDateDTO } from "@/domain/dto/UpdatePlanExpirationDateDTO";
import { AddPlanDTO } from "@/domain/dto/AddUsersToPlanDTO";
import { NetworkService } from "@/services/NetworkService";
import endpoints from "@/infrastructure/http/endpoints";
import { BatchResponseDTO } from "@/infrastructure/dto/BatchResponseDTO";
import { CodesResponseDTO } from "@/infrastructure/dto/CodesResponseDTO";
import { ListPartnerQueryParamsDTO } from "@/domain/dto/ListPartnerQueryParamsDTO";

export class PartnerRemoteDataSource implements IPartnerRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    listCodes(partnership_id: string): Promise<CodesResponseDTO> {
        return this.network.get(endpoints.partnership_codes, { partnership_id, limit: 2000 })
    }
    showBatch(batch_id: string): Promise<BatchResponseDTO> {
        return this.network.get(`${endpoints.partnership_batches}/${batch_id}`)
    }
    create(params: CreatePartnerDTO): Promise<PartnerCreateResponseDTO> {
        return this.network.post(endpoints.partnership, params)
    }
    show(id: string): Promise<PartnerShowResponseDTO> {
        return this.network.get(`${endpoints.partnership}/${id}`)
    }

    addUsersToPlan(params: AddPlanDTO): Promise<void> {
        return this.network.post(endpoints.partnership_codes, params)
    }

    list(params: ListPartnerQueryParamsDTO): Promise<PartnerListResponseDTO> {
        return this.network.get(endpoints.partnership, params)
    }

    updatePlanExpirationDate(params: UpdatePlanExpirationDateDTO): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 2500);
        });
    }

}